export default __webpack_public_path__ + "static/bg_top_service_01-4c511a5d853efa0acfa760429b56804c.mp4";